var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"timeline-item"},[_c('div',{staticClass:"item"},[_c('span',{staticClass:"dot",style:(_vm.getBackgroundColour(_vm.itemTimeline.color))}),_c('p',{staticClass:"description-item",domProps:{"innerHTML":_vm._s(_vm.itemTimeline.description)},on:{"click":_vm.handlePreview}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }